import {
  LoadingListCard,
  PaginationList,
  UnitCardList,
} from "Explore/Components";
import styles from "./UnitScholarAndPeers.module.scss";
import useExploreInfo from "Hooks/useExploreInfo";
import { useEffect, useRef, useState } from "react";
import { Empty } from "antd";
import { getUnitCollaboratorsById } from "Explore/Services/Unit";
import { useSelector } from "react-redux";
import _ from "lodash";
import ModeSelect from "Explore/Components/ModeSelect";
import { Grid } from "@mui/material";

const UnitCollaboratorList = () => {
  const { unit_id } = useExploreInfo();
  const { selectedKeywords } = useSelector((state) => state.conceptState) || {};
  const [data, setData] = useState({ data: [], isLoading: false });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 12,
    totalRows: 0,
  });
  const [mode, setMode] = useState("all");

  const prevFilter = useRef({});
  const grid =
    window.screen.width <= 480
      ? { gutter: 25, column: 1 }
      : window.screen.width <= 1024
        ? { gutter: 25, column: 3 }
        : { gutter: 25, column: 3 };

  useEffect(() => {
    const _prevFilter = prevFilter.current;
    if (
      !_.isEqual(_prevFilter, {
        unit_id,
        selectedKeywords,
        page: pagination.page,
        rowsPerPage: pagination.rowsPerPage,
        mode,
      })
    ) {
      let newPagination = { ...pagination };
      setData({ data: [], isLoading: true });

      if (
        _prevFilter.unit_id !== unit_id ||
        _prevFilter.selectedKeywords !== selectedKeywords ||
        _prevFilter.rowsPerPage !== pagination.rowsPerPage ||
        _prevFilter.mode !== mode
      ) {
        newPagination.page = 1;
      }

      getUnitCollaboratorsById({
        id: unit_id,
        keyword: selectedKeywords,
        mode,
        page: newPagination.page - 1,
        rowsPerPage: newPagination.rowsPerPage,
      })
        .then((res) => {
          setData({ data: res.results, isLoading: false });
          setPagination({ ...newPagination, totalRows: res.total });
        })
        .catch(() => {
          setData({ data: [], isLoading: false });
          setPagination({ ...newPagination, totalRows: 0 });
        });

      prevFilter.current = {
        unit_id,
        selectedKeywords,
        page: newPagination.page,
        rowsPerPage: newPagination.rowsPerPage,
        mode,
      };
    } else {
      prevFilter.current = {
        unit_id,
        selectedKeywords,
        page: pagination.page,
        rowsPerPage: pagination.rowsPerPage,
        mode,
      };
    }
  }, [pagination.page, pagination.rowsPerPage, unit_id, selectedKeywords, mode]);

  return (
    <div className={styles["list__wrapper"]}>
      <div className={styles["list__header"]}>
        <ModeSelect mode={mode} setMode={setMode} />
      </div>
      <div>
        <LoadingListCard
          isLoading={data.isLoading}
          grid={grid}
          component={
            data.data.length > 0 ? (
              <Grid container spacing="25px">
                {data.data.map((e, i) => (
                  <Grid item xs={12} key={i}>
                    <UnitCardList
                      data={e}
                      className={styles["entity-card"]}
                    />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Empty description="No Collaborators Found." />
            )
          }
          componentNum={9}
          rows={2}
          avatar={true}
        />
        <PaginationList
          pagination={pagination}
          setPagination={setPagination}
          pageSizeOptions={[12, 36, 48, 60]}
        />
      </div>
    </div>
  );
};

export default UnitCollaboratorList;

